import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Validation from "./Pages/Validation";
import Fixtures from "./Pages/Fixtures";
import Fixture from "./Pages/Fixture";
import Skillzone from "./Pages/Skillzone";
import SkillzoneGroup from "./Pages/SkillzoneGroup";
import SkillzoneAllTime from "./Pages/SkillzoneAllTime";
import SkillzoneLatest from "./Pages/SkillzoneAllTime";
import Login from "./Pages/Login";
import Leaderboard from "./Pages/Leaderboard";
import Friends from "./Pages/Friends";
import ManageFriends from "./Pages/ManageFriends";
import SelectUser from "./Pages/SelectUser";
import NoUser from "./Pages/NoUser";
import PreRegistrationRef from "./Pages/PreRegistrationRef/index.js";
import PreRegistration from "./Pages/PreRegistration/index.js";
import PreRegistrationFinished from "./Pages/PreRegistrationFinished/index.js";
import PreRegistrationEmail from "./Pages/PreRegistrationEmail/index.js";
import PreRegistrationSelectUser from "./Pages/PreRegistrationSelectUser/index.js";
import PreRegistrationConfirmDetails from "./Pages/PreRegistrationConfirmDetails/index.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { UsernameProvider } from "./Pages/UsernameContext";
import { PreRegProvider } from "./Pages/PreRegContext";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Skillzone />,
  },
  {
    path: "/skillzone/:bookingID",
    element: <Skillzone />,
  },
    {
    path: "/no-user",
    element: <NoUser />,
  },
  {
    path: "/select-user",
    element: <SelectUser />,
  },
  {
    path: "/skillzone/group/:bookingID",
    element: <SkillzoneGroup />,
  },
  {
    path: "/skillzone-all-time",
    element: <SkillzoneAllTime />,
  },
  {
    path: "/skillzone-latest",
    element: <SkillzoneLatest />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/leaderboard",
    element: <Leaderboard />,
  },
  {
    path: "/friends",
    element: <Friends />,
  },
  {
    path: "/friends/manage",
    element: <ManageFriends />,
  },
  {
    path: "/fixtures",
    element: <Fixtures />,
  },
  {
    path: "/fixture/:fixtureID",
    element: <Fixture />,
  },
  {
    path: "/user-auth/validation/:validation",
    element: <Validation />,
  },
    {
    path: "/pre-registration",
    element: <PreRegistrationRef />,
  },
  {
    path: "/pre-registration/:bookingReference",
    element: <PreRegistration />,
  },
  {
    path: "/pre-registration/finished",
    element: <PreRegistrationFinished />,
  },
  {
    path: "/pre-registration/email",
    element: <PreRegistrationEmail />,
  },
  {
    path: "/pre-registration/select-user",
    element: <PreRegistrationSelectUser />,
  },
  {
    path: "/pre-registration/confirm-details",
    element: <PreRegistrationConfirmDetails />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <UsernameProvider>
      <PreRegProvider>
        <RouterProvider router={router} />
      </PreRegProvider>
    </UsernameProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
